module.exports = __webpack_public_path__ + "static/media/seller_right_put_2x.8e5601ac.png";